import { render } from "./SVGWarning.vue?vue&type=template&id=f6b9190c"
import script from "./SVGWarning.vue?vue&type=script&lang=js"
export * from "./SVGWarning.vue?vue&type=script&lang=js"

import exportComponent from "/home/tachyon/wardrobe-test3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__